import React from 'react';
import KanbanCard from '../KanbanCard';
import { useDroppable } from '@dnd-kit/core';
import { Building2, Globe, Users, Settings } from 'lucide-react';

const ClientCard = ({ client, onManageAccess, onClick, isSelected = false }) => {
  const sitesCount = client.sitesCount || 0;
  const accessCount = client.accessCount || 0;

  // Zone de drop pour recevoir des sites
  const { isOver, setNodeRef } = useDroppable({
    id: `client-drop-${client.id}`,
    data: {
      type: 'client-drop-zone',
      clientId: client.id,
      accepts: ['site']
    }
  });

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '0.375rem'
  };

  const iconStyle = {
    width: '28px',
    height: '28px',
    borderRadius: '0.375rem',
    backgroundColor: '#f3efe7',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#64748b',
    flexShrink: 0
  };

  const nameStyle = {
    fontSize: '0.875rem',
    fontWeight: '600',
    color: '#1e293b',
    flex: 1,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  const descriptionStyle = {
    fontSize: '0.75rem',
    color: '#64748b',
    marginBottom: '0.5rem',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  };

  const statsRowStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '0.5rem',
    flexWrap: 'wrap'
  };

  const statBadgeStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
    fontSize: '0.7rem',
    padding: '0.125rem 0.375rem',
    borderRadius: '0.25rem'
  };

  const siteBadgeStyle = {
    ...statBadgeStyle,
    backgroundColor: sitesCount > 0 ? '#dcfce7' : '#f3efe7',
    color: sitesCount > 0 ? '#16a34a' : '#64748b'
  };

  const accessBadgeStyle = {
    ...statBadgeStyle,
    backgroundColor: accessCount > 0 ? '#dcfce7' : '#f3efe7',
    color: accessCount > 0 ? '#16a34a' : '#64748b'
  };

  const actionsRowStyle = {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '0.5rem',
    paddingTop: '0.5rem',
    borderTop: '1px solid #e5e0d5'
  };

  const accessButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
    padding: '0.25rem 0.5rem',
    fontSize: '0.7rem',
    fontWeight: '500',
    color: '#64748b',
    backgroundColor: '#f3efe7',
    border: 'none',
    borderRadius: '0.25rem',
    cursor: 'pointer',
    transition: 'all 0.2s'
  };

  const dropZoneStyle = {
    border: isOver ? '2px dashed #92400e' : '2px dashed transparent',
    borderRadius: '0.375rem',
    backgroundColor: isOver ? '#fef3c7' : 'transparent',
    padding: isOver ? '0.25rem' : '0',
    margin: isOver ? '-0.25rem' : '0',
    transition: 'all 0.2s ease'
  };

  return (
    <div ref={setNodeRef} style={dropZoneStyle}>
      <KanbanCard
        id={client.id}
        type="client"
        data={client}
        draggable={false}
        onClick={onClick}
        isSelected={isSelected}
      >
        <div>
          <div style={headerStyle}>
            <div style={iconStyle}>
              <Building2 size={16} />
            </div>
            <div style={nameStyle} title={client.name}>
              {client.name}
            </div>
          </div>

          {client.description && (
            <div style={descriptionStyle} title={client.description}>
              {client.description}
            </div>
          )}

          <div style={statsRowStyle}>
            <div style={siteBadgeStyle}>
              <Globe size={10} />
              <span>{sitesCount} site{sitesCount !== 1 ? 's' : ''}</span>
            </div>
            <div style={accessBadgeStyle}>
              <Users size={10} />
              <span>{accessCount} accès</span>
            </div>
          </div>

          {onManageAccess && (
            <div style={actionsRowStyle}>
              <button
                style={accessButtonStyle}
                onClick={(e) => {
                  e.stopPropagation();
                  onManageAccess(client);
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#e5e0d5';
                  e.currentTarget.style.color = '#475569';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#f3efe7';
                  e.currentTarget.style.color = '#64748b';
                }}
              >
                <Settings size={12} />
                Gérer les accès
              </button>
            </div>
          )}
        </div>
      </KanbanCard>
    </div>
  );
};

export default ClientCard;
